import { render, staticRenderFns } from "./o-compass.vue?vue&type=template&id=0a9e5db4&"
import script from "./o-compass.vue?vue&type=script&lang=js&"
export * from "./o-compass.vue?vue&type=script&lang=js&"
import style0 from "./o-compass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports